
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_3687_43247)"}},[_c('path',{attrs:{"d":"M14.3896 0.5H1.60742C0.995117 0.5 0.5 0.983398 0.5 1.58105V14.416C0.5 15.0137 0.995117 15.5 1.60742 15.5H14.3896C15.002 15.5 15.5 15.0137 15.5 14.4189V1.58105C15.5 0.983398 15.002 0.5 14.3896 0.5ZM4.9502 13.2822H2.72363V6.12207H4.9502V13.2822ZM3.83691 5.14648C3.12207 5.14648 2.54492 4.56934 2.54492 3.85742C2.54492 3.14551 3.12207 2.56836 3.83691 2.56836C4.54883 2.56836 5.12598 3.14551 5.12598 3.85742C5.12598 4.56641 4.54883 5.14648 3.83691 5.14648ZM13.2822 13.2822H11.0586V9.80176C11.0586 8.97266 11.0439 7.90332 9.90137 7.90332C8.74414 7.90332 8.56836 8.80859 8.56836 9.74316V13.2822H6.34766V6.12207H8.48047V7.10059H8.50977C8.80566 6.53809 9.53223 5.94336 10.6133 5.94336C12.8662 5.94336 13.2822 7.42578 13.2822 9.35352V13.2822Z","fill":"#10001F"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_3687_43247"}},[_c('rect',{attrs:{"width":"16","height":"16","fill":"white","transform":"matrix(-1 0 0 1 16 0)"}})])])])
          )
        }
      }
    